// ==============================|| OVERRIDES - TYPOGRAPHY ||============================== //

export default function Dialog() {
    return {
        MuiDialog: {
            styleOverrides: {
                root: {},
                paper: {},
            },
        },
    }
}
